import { Box, Typography } from '@mui/material';
import Image from 'next/image';

const DOUBLE_SPARKLE_SVG = 'https://www.nerdwallet.com/cdn/banking/spotlight/double-sparkle.svg';

export const SPOTLIGHT_BADGE_HEIGHT_PX = 38;

export const SPOTLIGHT_COMPACT_HEADING_MAX_LENGTH = 55;

type Props = {
  heading: string;
  variant?: 'compact' | 'full';
};

export function SpotlightBadge({ heading, variant = 'full' }: Props) {
  const isCompact = variant === 'compact';

  return (
    <Box
      sx={{
        backgroundColor: 'limes.tintLP2',
        display: 'flex',
        flexWrap: 'nowrap',
        minHeight: SPOTLIGHT_BADGE_HEIGHT_PX,
        alignItems: 'center',
        paddingX: 3,
        paddingY: 1,
        borderBottomLeftRadius: 16,
        borderBottomRightRadius: 16,
        columnGap: 2,
        boxSizing: 'border-box',
        width: 'fit-content',
        ...(isCompact ? { minWidth: '100%' } : { maxWidth: '100%' }),
      }}
      data-testid="spotlight-badge"
    >
      <Image
        src={DOUBLE_SPARKLE_SVG}
        alt=""
        width={31}
        height={23}
        unoptimized
        style={{ flexShrink: 0 }}
      />
      <Typography
        sx={{
          fontWeight: 500,
          fontSize: '14px',
          lineHeight: 'normal',
          color: 'text.primary',
          textAlign: 'left',
          ...(isCompact ? { whiteSpace: 'nowrap' } : { minWidth: 0, overflowWrap: 'break-word' }),
        }}
      >
        {heading}
      </Typography>
    </Box>
  );
}
